<template>
<Tooltip transfer :content="validMsg" theme="err" :disabled="!(validErr&&validErrMsgTip)"  class="ivu-table-cell-tooltip">
    <div  :class="getEditClass" v-click-outside.capture="onClickOutside"
        v-click-outside:mousedown.capture="onClickOutside" @mouseenter="validErrMsgTipIn" @mouseleave="validErrMsgTipOut">
        <template>
            <div :class="[prefixCls + '-rel']">
              <template>
                <Tooltip transfer :content="selectData" :disabled="!showTooltip" class="ivu-table-cell-tooltip">
                    <p ref="content" @mouseenter="handleTooltipIn" @mouseleave="handleTooltipOut" class="ivu-table-cell-tooltip-content">{{ selectData }}</p>
                </Tooltip>
              </template>
            </div>
            <template>
                <div :class="[prefixCls + '-popper']"
                    v-if="visible">
                    <div :class="[prefixCls + '-content']">
                        <DatePicker autofocus 
                            ref="datePicker"
                            :type="editCfg.type" 
                            @on-blur="handleBlur" 
                            :disabled="disabled"  
                            @on-change="change" 
                            :value="selectData" 
                            placeholder="Select date"></DatePicker>
                    </div>
                </div>
            </template>
        </template>
    </div>
</Tooltip>
</template>
<script>
import {directive as clickOutside} from '@/utils/component/v-click-outside-x';
import Tooltip from '../../tooltip/tooltip.vue';
const prefixCls = "table-edit";
export default {
  name: "plugDate",
  components:{Tooltip},
  directives: { clickOutside },
  computed: {
    getEditClass() {
      return [
        `${this.prefixCls}`,
        {
            [`${this.prefixCls}-always`]: (this.editAlways||this.always)&&!this.visible,
            [`${this.prefixCls}-disabled`]:this.getDisabled(),
            [`${this.prefixCls}-cell-valid-err`]: this.validErr === true&&!this.visible
        }
      ];
    }
  },
  props: {
    content: {
      type: [String, Number],
      default: ""
    },
    col: [String, Number, Object],
    row: [String, Number, Object],
    editCfg: Object,
    dropIndex: Number,
    dropInit: Boolean,
    disabled: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: false
    },
    always: {
      type: Boolean,
      default: false
    },
    validErr:{
      type: Boolean,
      default: false
    },
    validMsg:String,
    editAlways:{
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: [String, Number]
    }
  },
  data() {
    return {
      prefixCls: prefixCls,
      selectData: "",
      showTooltip: false,
      focus:false,
      validErrMsgTip:false
    };
  },
  watch: {
        visible(newValue,oldValue){
          if(newValue){
            this.$nextTick(function(){
              if(newValue)this.$refs.datePicker.focus()
              this.focus=true
            })
          }
        }
  },
  methods: {
    onClickOutside(){
      if(this.focus){
        this.focus=false
        this.$emit("onChangeShowEdit", false,this.selectData);
      }
    },
    handleBlur() {
      // this.$emit("onChangeShowEdit", false);
    },
    change(value) {
      this.selectData=value
      this.$emit("onChange", value, this.col);
    },
    handleTooltipIn () {
      const $content = this.$refs.content;
      this.showTooltip = $content.scrollWidth > $content.offsetWidth;
    },
    handleTooltipOut () {
      this.showTooltip = false;
    },
    validErrMsgTipIn(){
      this.validErrMsgTip=true
    },
    validErrMsgTipOut(){
      this.validErrMsgTip=false
    },
    getDisabled(item) {
       let myDisabled=this.editCfg.setDisabled
        ? this.editCfg.setDisabled(this.col, this.row, this.editCfg)
        : this.editCfg.disabled;
        if(myDisabled){
            this.$emit("setColEditDisabled", myDisabled);
        }
        return myDisabled
    },
  },
  mounted() {
    this.selectData = this.content;
  }
};
</script>




// WEBPACK FOOTER //
// src/components/common/table/plug/date.vue